import { render, staticRenderFns } from "./loginAll.vue?vue&type=template&id=b88c8036&scoped=true"
import script from "./loginAll.vue?vue&type=script&lang=js"
export * from "./loginAll.vue?vue&type=script&lang=js"
import style0 from "./loginAll.vue?vue&type=style&index=0&id=b88c8036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88c8036",
  null
  
)

export default component.exports